import { GameState } from "../enum/GameState";
import { PacketValueSerialType } from "../enum/PacketValueSerialType";
import NetworkBehavior from "../lib/NetworkBehavior";
import { Time } from "../lib/Time";
import { Physics } from "../math/Physics";
import Vector2 from "../math/Vector2";
import { clamp01 } from "../util";
import GameManager from "./GameManager";
import Player from "./Player";

export default class CTFFlag extends NetworkBehavior {

    team: "red"|"blue"|undefined;
    heldById: string|undefined;

    returnTimer = 30;
    
    get heldBy() {
        if (!this.heldById) return;

        return this.engine.GetGameObject(this.heldById)?.GetScript(Player);
    }

    HeldUpdate() {
        if (!this.heldBy || !GameManager.Singleton || !this.team) return;

        this.transform.position = this.heldBy.transform.position.add(Vector2.one.scale(this.heldBy.size));
        this.returnTimer = 30;
        if (this.heldBy.isDead) this.heldById = undefined;
        const otherTeam = this.team === "red" ? "blue" : "red";
        const otherTeamSpawn = GameManager.spawns[otherTeam];

        if (Vector2.distance(otherTeamSpawn, this.transform.position) <= 64) {

            //is the other flag at base?
            const otherFlag = this.engine.GetGameObjectsBehaviors<CTFFlag>(CTFFlag).filter(v => v.team !== this.team)[0];
            
            if (!otherFlag || Vector2.distance(otherFlag.transform.position, otherTeamSpawn) > 1) return;

            GameManager.Singleton.score[otherTeam]++;
            this.heldById = undefined;
            this.transform.position = GameManager.spawns[this.team];
            this.engine.sendChat(`${this.team} flag has been captured! ${otherTeam} scores!`);
        }
    }

    Update(): void {
        if (!this.isHost || !this.team || GameManager.Singleton?.getGameState() !== GameState.InGame) {
            if (GameManager.Singleton?.getGameState() !== GameState.InGame && this.heldById) {
                this.heldById = undefined;
                if (this.team) this.transform.position = GameManager.spawns[this.team];
            }
            return;
        }

        if (this.heldBy) {
            this.HeldUpdate();
        } else {
            const distToBase = Vector2.distance(this.transform.position, GameManager.spawns[this.team]);

            if (distToBase > 1) {
                this.returnTimer -= Time.deltaTime;

                if (this.returnTimer <= 0) {
                    this.returnTimer = 30;
                    this.transform.position = GameManager.spawns[this.team];
                    this.engine.sendChat(`${this.team} flag has been returned`);
                }
            }

            const enemyPlayers = this.engine.GetGameObjectsBehaviors<Player>(Player).filter(
                v => !v.isDead && v.team && v.team !== this.team
            );
    
            for (const player of enemyPlayers) {
                if (Physics.CircleCircleCollision({
                    position: this.transform.position,
                    radius: 8
                }, {
                    position: player.transform.position,
                    radius: player.size
                }) !== false) {
                    this.heldById = player.gameObject.id;
                    this.engine.sendChat(`${this.team} flag has been taken!`);
                    break;
                }
            }

            const teamPlayers = this.engine.GetGameObjectsBehaviors<Player>(Player).filter(
                v => !v.isDead && v.team && v.team === this.team
            );
    
            for (const player of teamPlayers) {
                if (Physics.CircleCircleCollision({
                    position: this.transform.position,
                    radius: 8
                }, {
                    position: player.transform.position,
                    radius: player.size
                }) !== false && this.team && distToBase > 1) {
                    this.transform.position = GameManager.spawns[this.team];
                    this.engine.sendChat(`${this.team} flag has been returned`);
                    break;
                }
            }
        }

        this.engine.sendUpdateObjectPacket(this.gameObject, {
            "CTF_FLAG": [
                {
                    key: "heldById",
                    value: this.heldById || "",
                    type: PacketValueSerialType.String
                }
            ]
        });
    }

    Draw(): void {
        this.engine.drawTextsWorldPosition(['⚑'], this.transform.position, {
            align: "center",
            baseline: "middle",
            color: this.team || 'white',
            size: 16
        });

        this.engine.drawUIMarker(this.transform.position, this.team || "white", this.engine.clientPlayer?.velocity.magnitude ?? 0);
    }

    DrawGizmos(): void {
        this.ctx.fillStyle = '#ffffff55';
        this.engine.FillRect(this.transform.position.add(new Vector2(-25, 12)), new Vector2(50, 4));
        this.ctx.fillStyle = '#ffffff';
        this.engine.FillRect(this.transform.position.add(new Vector2(-25, 12)), new Vector2(50 * clamp01(this.returnTimer / 30), 4));
    }

}